export const PRE_ORDER_TABLE = "preOrders"
// Indexed for: list-by-company, by-status (recap section filtering), by-chat
// (pre-order divider in chat panel), by-partner (recap grouping), by-deletion
// (filter out tombstones), by-syncId (delta resume), and — critically for
// recap perf — by deliveryDate / orderDate so the recap shim can fetch only
// the few POs in the active date scope instead of pulling the full 20k+ rows
// into JS and `.filter()`ing them.
//
// The `[companyId+category+deliveryDate]` / `[companyId+category+orderDate]`
// compounds (v39) prefix the date scope with `category` so /recap and
// /purchases each get their own independent oldest-N-of-category window
// instead of sharing one combined cap (which silently dropped purchase rows
// behind sales rows in the merged set).
export const PRE_ORDER_TABLE_SCHEMA =
  "id, companyId, userId, status, partnerId, whatsappChatId, emailId, smsChatId, deletedAt, syncId, deliveryDate, orderDate, [companyId+status], [companyId+deliveryDate], [companyId+orderDate], [companyId+category+deliveryDate], [companyId+category+orderDate]"
